import { ComponentAPI } from '@philips-emr/tws-core';

class SocialNetworksAPI extends ComponentAPI {
  getFacebook(): string {
    return this.StaticRange.facebook;
  }

  setFacebook(facebook: string): void {
    this.setState({ facebook });
  }

  getInstagram(): string {
    return this.StaticRange.instagram;
  }

  setInstagram(instagram: string): void {
    this.setState({ instagram });
  }

  getLinkedin(): string {
    return this.StaticRange.linkedin;
  }

  setLinkedin(linkedin: string): void {
    this.setState({ linkedin });
  }

  getTwitter(): string {
    return this.StaticRange.twitter;
  }

  setTwitter(twitter: string): void {
    this.setState({ twitter });
  }

  getYoutube(): string {
    return this.StaticRange.youtube;
  }

  setYoutube(youtube: string): void {
    this.setState({ youtube });
  }
}

export default SocialNetworksAPI;
